import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
// 导入自己需要的组件
import {
  Tree,
  Form,
  Tag,
  FormItem,
  Select,
  Option,
  OptionGroup,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Checkbox,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Tooltip,
  CheckboxButton,
  Button,
  MessageBox,
  Message
} from 'element-ui'
const element = {
  install: function (Vue) {
    Vue.use(Tree)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(OptionGroup)
    Vue.use(Input)
    Vue.use(Breadcrumb)
    Vue.use(BreadcrumbItem)
    Vue.use(Tag)
    Vue.use(Checkbox)
    Vue.use(CheckboxGroup)
    Vue.use(RadioGroup)
    Vue.use(Radio)
    Vue.use(Tooltip)
    Vue.use(CheckboxButton)
	Vue.use(Button)
  }
}
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.use(element)



// WEBPACK FOOTER //
// ./src/plugins/elementui.js